export default __webpack_public_path__ + "static/media/grey-close.26e2721e.svg";